type YMInitOptions = {
  defer?: boolean;
  clickmap?: boolean;
  trackLinks?: boolean;
  accurateTrackBounce?: boolean;
  webvisor?: boolean;
  [key: string]: unknown;
};

type YMHitOptions = {
  params?: Record<string, unknown>;
  referer?: string;
  title?: string;
  callback?: () => void;
  ctx?: unknown;
};

export interface YMFunction {
  (
    counterId: number,
    method: 'init',
    options: YMInitOptions,
  ): void;

  (
    counterId: number,
    method: 'hit',
    url: string,
    options?: YMHitOptions,
  ): void;

  (
    counterId: number,
    method: 'reachGoal',
    goalName: string,
    params?: Record<string, unknown>,
  ): void;

  (
    counterId: number,
    method: 'params' | 'userParams',
    params: Record<string, unknown>,
  ): void;

  (...args: unknown[]): void;
}


function getYM(): YMFunction | undefined {
  const w = window as unknown as { ym?: YMFunction };
  return w.ym;
}


export function ymInit(counterId: number, options: YMInitOptions): void {
  const ym = getYM();
  if (ym) ym(counterId, 'init', options);
}

export function ymHit(counterId: number, url: string, options?: YMHitOptions): void {
  const ym = getYM();
  if (ym) ym(counterId, 'hit', url, options);
}

export function ymReachGoal(
  counterId: number,
  goal: string,
  params?: Record<string, unknown>,
): void {
  const ym = getYM();
  if (ym) ym(counterId, 'reachGoal', goal, params);
}

export function ymParams(
  counterId: number,
  params: Record<string, unknown>,
): void {
  const ym = getYM();
  if (ym) ym(counterId, 'params', params);
}

export function ymUserParams(
  counterId: number,
  params: Record<string, unknown>,
): void {
  const ym = getYM();
  if (ym) ym(counterId, 'userParams', params);
}